export type Value = string | number | boolean | undefined | null;
export type Mapping = Record<string, unknown>;
export type ArgumentArray = Array<Argument>;
export type Argument = Value | Mapping | ArgumentArray;

export default function classnames(...args: ArgumentArray): string {
  const classes = [];

  for (const arg of args) {
    if (!arg) continue;

    const argType = typeof arg;

    switch (argType) {
      case 'string':
      case 'number':
        classes.push(arg);
        break;
      case 'object':
        if (Array.isArray(arg)) {
          if (!arg.length) break;
          const inner = classnames(...arg);
          if (inner) classes.push(inner);
          break;
        }

        if (arg.toString !== Object.prototype.toString) {
          classes.push(arg.toString());
          break;
        }

        for (const key of Object.keys(arg)) {
          if (Object.prototype.hasOwnProperty.call(arg, key) && (arg as Mapping)[key]) {
            classes.push(key);
          }
        }

        break;
    }
  }

  return classes.join(' ');
}
